<template>
  <div class="calc-select" :tabindex="10" @blur="open = false">
    <div class="calc-select__selected" @click="open = !open">
      <label
        class="calc-select__label"
        :class="{ 'calc-select__label--center': !open && !selected }"
        >{{ label }}</label
      >
      <span>{{ selected?.name }}</span>
      <svg
        class="calc-select__icon"
        :class="{ 'calc-select__icon--rotate': open }"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M18.53 9.53a.75.75 0 0 0 0-1.06H5.47a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06 0z"
        />
      </svg>
    </div>
    <div
      class="calc-select__items"
      :class="{ 'calc-select__items--hide': !open }"
    >
      <div
        class="calc-select__option"
        :class="{ 'calc-select__option--selected': option.id === selected?.id }"
        v-for="(option, i) of options"
        :key="i"
        @click="
          selected = option
          open = false
          $emit('input', option.id)
        "
      >
        {{ option.name }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

interface Option {
  name: string
  id: number
}

interface Data {
  selected: Option | null
  open: boolean
}

export default defineComponent({
  name: 'CalcSelect',
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Option[],
      default: null,
    },
  },
  data(): Data {
    return {
      selected: null,
      open: false,
    }
  },
  mounted() {
    this.$emit('input', this.selected)
  },
})
</script>

<style lang="scss" scoped>
.calc-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 100%;

  &__selected {
    height: 100%;
    width: 100%;
    cursor: pointer;
    user-select: none;

    span {
      position: absolute;
      left: 24px;
      right: 28px;
      top: 0;
      line-height: 48px;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  &__icon {
    color: #960000;
    position: absolute;
    content: '';
    width: 18px;
    top: 8px;
    right: 8px;
    transition: transform 0.2s;

    &--rotate {
      transform: rotate(180deg);
    }
  }

  &__label {
    cursor: pointer;
    position: absolute;
    top: -8px;
    left: 20px;
    padding: 0 4px;
    background: #fff;
    color: #960000;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;

    &--center {
      font-size: 16px;
      top: 14px;
    }
  }

  &__items {
    color: #000;
    border-radius: 12px;
    padding: 8px 0;
    overflow: hidden;
    position: absolute;
    background-color: #fff;
    left: 0;
    width: 400px;
    z-index: 100;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);

    &--hide {
      display: none;
    }
  }

  &__option {
    position: relative;
    height: 38px;
    padding: 8px 24px;
    border-radius: 8px;
    margin: 0 8px;
    cursor: pointer;
    user-select: none;

    &--selected,
    &:hover {
      background-color: #f5f5f5;
    }

    &::after {
      position: absolute;
      content: '';
      top: 7px;
      right: 22px;
      width: 22px;
      height: 22px;
      border-radius: 100%;
      border: 1px solid #d9d9d9;
    }
  }
}
</style>
